import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientXsrfModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './modules/layout/layout.module';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { MaintenanceInterceptor } from './shared/interceptors/maintenance.interceptor';
import { MaintenanceModule } from './modules/maintenance/maintenance.module';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { SharedModule } from './shared/modules/shared.module';

import { EchoService } from './services/echo.service';
@NgModule({
	declarations: [AppComponent],
	imports: [
		AppRoutingModule,
		AppLayoutModule,
		BrowserModule,
		BrowserAnimationsModule,
		MaintenanceModule,
		SharedModule,
		HttpClientXsrfModule.withOptions({
			cookieName: 'company_XSRF-TOKEN',
			headerName: 'X-XSRF-TOKEN'
		})
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MaintenanceInterceptor,
			multi: true
		},
		EchoService
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
